interface Props {
  size?: number;
  className?: string;
}

/** Pure SVG Captain America shield — scalable + no external deps. */
export function ShieldLogo({ size = 96, className }: Props) {
  return (
    <svg
      viewBox="0 0 100 100"
      width={size}
      height={size}
      className={className}
      aria-hidden="true"
    >
      <circle cx="50" cy="50" r="48" fill="#c8102e" />
      <circle cx="50" cy="50" r="38" fill="#f8f9fa" />
      <circle cx="50" cy="50" r="28" fill="#c8102e" />
      <circle cx="50" cy="50" r="18" fill="#0a3161" />
      <polygon
        fill="#f8f9fa"
        points="50,38 53,46 62,46 55,52 58,60 50,55 42,60 45,52 38,46 47,46"
      />
    </svg>
  );
}
